<!--
  @description 告警管理
  @author lixiaohua
  @date 2021/08/07
-->
<template>
  <div class="alarmManagement__content">
    <el-form ref="searchForm"
      :model="searchForm"
      :inline="true">
      <el-form-item :label="$t('alarmManagement.alarmLevel')"
        input-width="auto">
        <g-select :list="alarmLevelList"
          :defaultAll="true"
          v-model="searchForm.alarmLevel"></g-select>
      </el-form-item>
      <el-form-item :label="$t('alarmManagement.startTime')"
        input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="yyyy-MM-dd HH:mm"
            style="width: 180px;"
            v-model="searchForm.alarmStartTime"
            type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime"
          style="margin-left: 10px">
          <el-date-picker value-format="yyyy-MM-dd HH:mm"
            style="width: 180px;"
            v-model="searchForm.alarmEndTime"
            type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item :label="$t('alarmManagement.processor')"
        input-width="auto">
        <g-select :list="processorlList"
          :defaultAll="true"
          v-model="searchForm.processor"></g-select>
      </el-form-item>
      <el-form-item :label="$t('alarmManagement.processingResults')"
        input-width="auto">
        <g-select :list="processingResultsList"
          :defaultAll="true"
          v-model="searchForm.processingResults"></g-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
          @click="e_search"
          v-g-rac="gRac('alarmManagement@search')"
          v-text="$t('common.search')"></el-button>
        <el-button type="primary"
          @click="e_batchUpdate"
          v-g-rac="gRac('alarmManagement@batchUpdate')"
          v-text="$t('serverMonitor.handle')"></el-button>
      </el-form-item>
    </el-form>
    <div>
      <el-table-extend :data="tData"
        :head="tHead"
        :currentChange="tCurrentChange"
        :sizeChange="tSizeChange"
        :selection="true"
        :selectionChange="selectionChange"
        border>
        <template slot="control-column"
          slot-scope="{data}">
          <el-table-extend-control :control="tableControl"
            :data="data"
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
    </div>
    <dialog-form key="alarmEdit"
      :title="dialogTitle"
      :size="2"
      :label-size="2"
      :visible.sync="dialogFormShow"
      :model="dialogForm"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="e_updateConfirm">
    </dialog-form>
    <dialog-detail key="alarmDetail"
      :title="dialogTitle"
      :size="2"
      :label-size="2"
      :visible.sync="dialogDetailShow"
      :model="alarmDetailModel"
      :detail-data="dialogDataForDetail"
      :cancel-fun="e_detailCancel">
    </dialog-detail>
  </div>
</template>

<script>
import rac from "@/plugins/rac-mixin";
import dic from "@/components/mixins/dic";
import table from "@/components/mixins/table";
import dialogForm from "@/components/dialogForm";
import dialogDetail from "@/components/dialogDetail";
import alarmManageBiz from "@/logic/statistics/alarmManagementBiz";
import TimeFormat from "@/utils/timeFormat";
import { extend, getKeyByValue } from "@/utils/tool";

export default {
  mixins: [rac, table, dic],
  data() {
    const that = this;
    return {
      searchForm: {
        alarmLevel: "",
        alarmStartTime: "",
        alarmEndTime: "",
        processor: "",
        processingResults: ""
      },
      dialogForm: {
        id: "",
        alarmName: "",
        alarmTime: "",
        alarmLevel: "",
        alarmSource: "",
        group: "",
        alarmDetails: "",
        affectedScope: "",
        analysisMethod: "",
        processingMethod: "",
        processingResults: ""
      },
      alarmLevelList: {},
      processorlList: {},
      processingResultsList: {},
      dialogDetailShow: false,
      alarmDetailModel: {},
      dialogData: [],
      dialogFormShow: false,
      dialogTitle: "",
      dialogFormRule: {},
      selectedIds: [],
      tableControl: [
        {
          label: that.$t("common.check"),
          callback: that.e_detail,
          rac: () => that.gRac("alarmManagement@check")
        },
        {
          label: that.$t("common.edit"),
          callback: that.e_update,
          rac: () => that.gRac("alarmManagement@edit")
        }
      ]
    };
  },
  components: {
    dialogForm,
    dialogDetail
  },
  computed: {},
  methods: {
    async preInitTable() {
      await Promise.all([
        this.dGetDictionaryByCode("alarmProcessResult"),
        this.dGetDictionaryByCode("alarmLevel"),
        alarmManageBiz.getUsers().then(data => {
          let res = {};
          data.map(item => {
            res[item.userName] = item.userName;
          });
          this.processorlList = { ...res };
        })
      ]);
      this.processingResultsList = { ...this.dDictionary.alarmProcessResult };
      this.alarmLevelList = { ...this.dDictionary.alarmLevel };
      this.initTable();
      this.setDialogData();
    },
    initTable() {
      const that = this;
      this.tInitTable({
        lanKey: "alarmManagement.table",
        head: [
          "id",
          "alarmName",
          "alarmTime",
          "alarmLevel",
          "alarmSource",
          "group",
          "processor",
          "alarmDetails",
          "processingResults",
          "processingTime"
        ],
        requestFun: this.search,
        headOpt: {
          alarmLevel: {
            formatter: "Dictionary",
            formatterDic: that.alarmLevelList
          },
          alarmTime: {
            formatter: "Date"
          },
          processingResults: {
            formatter: "Dictionary",
            formatterDic: that.processingResultsList
          }
        }
      });
    },
    setDialogData() {
      this.dialogData = [
        {
          label: this.$t("alarmManagement.table.alarmName"),
          key: "alarmName",
          disabled: true
        },
        {
          label: this.$t("alarmManagement.table.alarmTime"),
          key: "alarmTime",
          disabled: true
        },
        {
          label: this.$t("alarmManagement.table.alarmLevel"),
          key: "alarmLevel",
          disabled: true,
          type: "select",
          select: this.alarmLevelList
        },
        {
          label: this.$t("alarmManagement.table.alarmSource"),
          key: "alarmSource",
          disabled: true
        },
        {
          label: this.$t("alarmManagement.table.group"),
          key: "group",
          disabled: true
        },
        {
          label: this.$t("alarmManagement.table.alarmDetails"),
          key: "alarmDetails",
          type: "textarea",
          disabled: true
        },
        {
          label: this.$t("alarmManagement.affectedScope"),
          key: "affectedScope",
          type: "textarea",
          disabled: true
        },
        {
          label: this.$t("alarmManagement.analysisMethod"),
          key: "analysisMethod",
          type: "textarea",
          disabled: true
        },
        {
          label: this.$t("alarmManagement.processingMethod"),
          key: "processingMethod",
          type: "textarea"
        },
        {
          label: this.$t("alarmManagement.table.processingResults"),
          key: "processingResults",
          type: "select",
          select: this.processingResultsList
        }
      ];
      this.dialogDataForDetail = this.dialogData.map(item => {
        return {
          label: item.label,
          key: item.key
        };
      });
    },
    search() {
      const reqData = extend(true, { ...this.tPageInfo }, this.searchForm, {
        alarmEndTime: TimeFormat.formatTimeTolong(this.searchForm.alarmEndTime),
        alarmStartTime: TimeFormat.formatTimeTolong(
          this.searchForm.alarmStartTime
        )
      });
      Object.keys(reqData).map(item => {
        if (reqData[item] === "") {
          delete reqData[item];
        }
      });
      alarmManageBiz.getAlarmList(reqData).then(data => {
        data.dataList.forEach(item => {
          item.processingTime = this.dateFomatter(item.processingTime);
          if (item.processor) item.processor = item.processor.toString();
        });
        this.tData = data;
      });
    },
    confirmMsgBox(tip) {
      return this.$confirm(tip, this.$t("common.tips"), {
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        type: "warning"
      });
    },
    selectionChange(da) {
      this.selectedIds = da.map(item => {
        return item.id;
      });
    },
    sucTip() {
      this.$message({
        message: this.$t("common.success"),
        type: "success"
      });
    },
    dateFomatter(timestamp) {
      if (!timestamp) return "";
      const date = new Date(timestamp);
      return (
        date.getFullYear() +
        "-" +
        parseInt(date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds()
      );
    },
    e_search() {
      this.tResetPage();
      this.search();
    },
    e_update(row, index, data) {
      for (const key in this.dialogForm) {
        if (row[key]) {
          this.dialogForm[key] =
            key == "processingResults"
              ? getKeyByValue(this.processingResultsList, row[key])
              : row[key];
        }
      }
      this.dialogTitle = this.$t("common.edit");
      this.dialogFormShow = true;
    },
    e_detail(row, index, data) {
      this.dialogTitle = this.$t("common.check");
      this.alarmDetailModel = row;
      this.dialogDetailShow = true;
    },
    e_detailCancel() {
      this.alarmDetailModel = {};
    },
    e_updateConfirm(da) {
      da.alarmTime = TimeFormat.formatTimeTolong(da.alarmTime);
      alarmManageBiz.updateAlarm({ ...da }).then(() => {
        this.dialogFormShow = false;
        this.sucTip();
        this.e_search();
      });
    },
    e_batchUpdate() {
      if (!this.selectedIds.length)
        return this.$message({
          message: this.$t("common.selectTips"),
          type: "warning"
        });
      this.confirmMsgBox(
        this.$t("alarmManagement.batchUpdateConfirmTips")
      ).then(() => {
        alarmManageBiz.batchUpdateAlarm({ ids: this.selectedIds }).then(res => {
          this.sucTip();
          this.e_search();
        });
      });
    },
    initSearch() {
      const today = TimeFormat.getTodayFormatShort();
      this.searchForm.alarmStartTime = `${today} 00:00:00`;
      this.searchForm.alarmEndTime = `${today} 23:59:59`;
      this.e_search();
    }
  },
  watch: {},
  mounted() {
    this.preInitTable();
    this.initSearch();
  }
};
</script>